/*
The datasets component.
*/

<template>
  <div class="datasets-wrapper">
    <base-datasets>
      <template #search-result-filters>
        <!-- This slot is empty on purpose -->
        <div />
      </template>
      <template #search-result-count-alert>
        <datasets-results-info
          :sort-options="sortOptions"
          :sort-dropdown-after-count="3"
          :loading-message="$t('message.datasets.loadingMessage')"
          :count-message="$t('message.datasets.countMessage')"
          :result-count="getDatasetsCount"
          :is-loading="getLoading"
          :sort-query="getSort"
        />
      </template>
    </base-datasets>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseDatasets from '@/components/piveau-ui-core/Datasets';
import DatasetsResultsInfo from '@/components/common/DatasetsResultsInfo';

export default {
  name: 'Datasets',
  components: {
    BaseDatasets,
    DatasetsResultsInfo,
  },
  data() {
    return {
      sortOptions: [
        { sort: 'deadline', order: 'desc', text: 'Stichtag' },
        { sort: `title.${this.$i18n.locale}`, order: 'asc', text: this.$t('message.sort.nameAZ') },
        { sort: 'relevance', order: 'desc', text: this.$t('message.sort.relevance') },
      ],
      sortSelected: 'relevance+desc, modification_date+desc, title.en+asc',
      sortSelectedLabel: this.$t('message.sort.lastUpdated'),
    }
  },
  computed: {
      ...mapGetters('datasets', [
        'getDatasetsCount',
        'getLoading',
        'getSort'
    ]),
  },
  methods: {
    setSortMethod(method, order, label) {
        this.sortSelectedLabel = label;
        this.sortSelected = `${method}+${order}`;
        this.$router.replace({ query: Object.assign({}, this.$route.query, { sort: `${method}+${order}` }) });
      },
  }
}
</script>

<style scoped lang="scss">
  @import '~@/styles/bootstrap_theme.scss';

  .datasets-wrapper {
    /deep/ .datasets {
      .data-info-box {
        &:hover {
          box-shadow: 8px 28px 50px rgba(39,44,49,.06), 1px 6px 12px rgba(39,44,49,.04);
        }
      }
    }
  }
</style>
